import React from 'react';
import { connect } from 'react-redux';

import { toggleChat } from 'apps/auth/actions/chatAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import OnfidoDocList from 'apps/auth/components/common/onfido/OnfidoDocList';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { resolveArguments } from 'apps/auth/helpers/utils';

const ModalDocsList = (props) => {
    return (
        <ModalComponent>
            <HeaderPanel title={resolveArguments(props.titleWithParams, props.country.name)} />
            <OnfidoDocList acceptableDocuments={props.docs?.acceptableDocuments} />
            <Button
                variant="row"
                onClick={(e) => {
                    e.preventDefault();
                    props.toggleChat(true);
                }}
                caption={props.needHelpWithDocument}
                negativeMargin
            />
        </ModalComponent>
    );
};
const mapStateToProps = (state) => {
    return {
        titleWithParams: state.messages.pageMessages.titleWithParams,
        needHelpWithDocument: state.messages.pageMessages.needHelpWithDocument,
    };
};
export default connect(mapStateToProps, { toggleChat })(ModalDocsList);
